import axios from '@/lib/AxApi';

export default {
  getGlobals(cb)
  {
    axios.get('/Session/returnJsVars')
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  login(data, cb)
  {
    axios.post('/Session/loginUser', data)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  logout(cb)
  {
    axios.post('/Session/logOut', {})
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  fetchLanguage(langId, cb)
  {
    axios.get('/Translator/getTranslationByLangId',
    {
      params: {
        langId: langId
      }
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  checkTrans: function(key)
  {
    axios.post('/Translator/checkTrans', {key: key})
  },
  requestResetPassword(data, cb)
  {
    axios.post('/Session/requestResetPassword', data)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      cb({ error: true, notice: 'GENERICERROR' });
    })
  },
  resetPassword(data, cb)
  {
    axios.post('/Session/resetPassword', data)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      if (e.response && e.response.data) {
        cb(e.response.data);
      } else {
        cb({ error: true, notice: 'GENERICERROR' });
      }
    })
  }
}
